export default {
  empty: {
    title: 'לא נמצאו פריטים מתאימים',
    subtitle: 'נסה לשנות את המסננים ולבצע חיפוש חדש',
  },
};
